import { network } from 'services/network';

import { QueryParams } from 'api/queries/getResourceTable.query';

const ENDPOINT = 'api/bo/getResourceTable';

export const getResourceTable = (params: QueryParams, endpoint = ENDPOINT) => {
    return network.post(endpoint, params).then((response) => {
        return response.data;
    });
};
